import {
  getViewPortHeight,
  getCurrentPage,
  isMobile,
  getBrowser,
  setStyle,
  calcPageScrollPercent
} from './utils'

function animateWearImages() {
  if (!isMobile() && getBrowser() !== 'ie' && getCurrentPage() === 'wear-images') {
    const percent = calcPageScrollPercent('wear-images')
    scrollImageColumns(percent)
  }
}

function scrollImageColumns (percent) {
  const imageColumns = document.getElementsByClassName('wear-images-column')
  let evenColumn = false // 是否是偶数列
  // Edge 不支持 DOM Collection 的迭代，故此处不能使用 for of
  for (let i = 0; i < imageColumns.length; i++) {
    const imageColumn = imageColumns[i]
    let top
    let vh = getViewPortHeight()
    if (vh > 1200) vh = 1200
    let scrollOffset = imageColumn.clientHeight / 1.5 - vh
    if (evenColumn) {
      // 偶数列
      top = (percent - 1) * scrollOffset
    } else {
      // 奇数列
      top = (0 - percent) * scrollOffset
    }
    setStyle(imageColumn, {
      top: `${top}px`
    })
    evenColumn = !evenColumn
  }
}

export {
  animateWearImages
}
